import { BaseModel } from "model/BaseModel";
import ProdutoOperacao from "model/meta/producao/ProdutoOperacao";
import Roteiro from "model/producao/Roteiro";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import ComponenteProduto from "./ComponenteProduto";
import FamiliaProduto from "./FamiliaProduto";
import ProdutoEstagioPlano from "./ProdutoEstagioPlano";
import Usuario from "../Usuario";
import ClassificacaoFiscal from "model/fiscal/ClassificacaoFiscal";

export default class Produto implements BaseModel {
    idSituacaoTributaria?: number | null;
    idIcmsEspecial?: number | null;
    idReducaoImposto?: number | null;
    idSubstituicaoTributaria?: number | null;
    idDispositivoFiscal?: number | null;


    id: number;
    codigo: string | null;
    nome: string;
    codigoInterno: string | null;
    ativo: boolean;
    entraBloqueado: boolean;
    patrimoniavel: boolean;
    tipo: string;
    unidadeMedida: string;
    qtdMinima: number;
    precoMedio: number | null;
    usuarioAlteracaoPreco: Usuario | null;
    precoCongelado: boolean;
    dataAlteracaoPreco: Date | null;
    qtdSaca: number;
    nrValidadeMeses: number;
    familiaProduto: null | FamiliaProduto;
    roteiro: Roteiro | null;
    componentes: ComponenteProduto[];
    planosEstagio: ProdutoEstagioPlano[];
    operacoes: ProdutoOperacao[];
    planoInspecao: PlanoInspecao|null;
    classificacaoFiscal: ClassificacaoFiscal | null = null;
    ean: string | null = null;
    origemMercadoria: string | null = null;
    unidadeTributavel: string | null = null;
    conversaoUnidadeTributavel: number | null = null;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        codigoInterno = "",
        ativo = true,
        entraBloqueado = false,
        patrimoniavel = false,
        tipo = "COMPRADO",
        unidadeMedida = "UN",
        qtdMinima = 0,
        nrValidadeMeses = 0,
        precoMedio = null,
        usuarioAlteracaoPreco = null,
        precoCongelado = false,
        dataAlteracaoPreco = null,
        qtdSaca = 0,
        familiaProduto = null,
        roteiro = null,
        componentes = [],
        planosEstagio = [],
        operacoes = [],
        planoInspecao = null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.codigoInterno = codigoInterno;
        this.ativo = ativo;
        this.entraBloqueado = entraBloqueado;
        this.patrimoniavel = patrimoniavel;
        this.tipo = tipo;
        this.unidadeMedida = unidadeMedida;
        this.qtdMinima = qtdMinima;
        this.precoMedio = precoMedio;
        this.usuarioAlteracaoPreco = usuarioAlteracaoPreco;
        this.precoCongelado = precoCongelado;
        this.dataAlteracaoPreco = dataAlteracaoPreco;
        this.qtdSaca = qtdSaca;
        this.nrValidadeMeses = nrValidadeMeses;
        this.familiaProduto = familiaProduto;
        this.roteiro = roteiro;
        this.componentes = componentes;
        this.planosEstagio = planosEstagio;
        this.operacoes = operacoes;
        this.planoInspecao = planoInspecao;
    }

}
